import { urql } from '../';

import { stopImpersonatingTokens } from './axios';

export async function stopImpersonating() {
  stopImpersonatingTokens();
  urql.reset();
}
